export default __webpack_public_path__ + "a819027125adc4d37468806f7b0b7867.png";